import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	

	addExcelUpload: ({ formData }) => {
		//엑셀업로드
		const url = `${BASE_URL}/pqy/pcku/mdjRslt/v1/excelMdjCku`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				console.log("error: ",  error);
				throw new Error(error.response.data);
			});
	},

	async getMdjRsltList({ searchParams, groups }) {
		let queryStr = '';
		queryStr = objectToQueryString({
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			rollId: searchParams.rollId,
			cellId: searchParams.cellId,
			partNo: searchParams.partNo,
			prvsClCd: searchParams.prvsClCd,
			ckuPrvsCd: searchParams.ckuPrvsCd,
			rsltCd: searchParams.rsltCd,
			currentPage: groups.currentPage,
			pageUnit: groups.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/mdjCkuList${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},

	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/searchCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
};
